<template>
  <div class="validation_request_address_container" >
    <div class="addresse">
      <h5>{{this.get_str_title()}}</h5>
      <ul>
        <li v-if="address.attributes.corporation_name">{{address.attributes.corporation_name}}</li>
        <li v-if="address_name">{{address_name}}</li>
        <li>{{address.attributes.street_line1}}</li>
        <li v-if="address.attributes.street_line2">{{address.attributes.street_line2}}</li>
        <li>{{address.attributes.zipcode}} {{address.attributes.city}}</li>
        <li>
          {{getUsStateTranslatedValue(address.attributes.state)}} 
          {{getCountryTranslatedValue(address.attributes.country)}}
        </li>
      </ul>
    </div>
    <div v-if="'mail_forward' === address.attributes.address_type" class="informations-complement">
      <h5>Informations complémentaires</h5>
       <ul>
        <li v-if="address.attributes.mail_forward_default"> Adresse de réexpédition par défaut</li>
        <li v-if="address.attributes.mail_forward_start_date"> Date de début d'usage pour réexpédition : {{ address.attributes.mail_forward_start_date | moment-date }}</li>
        <li v-if="address.attributes.mail_forward_end_date"> Date de fin d'usage pour réexpédition : {{ address.attributes.mail_forward_end_date | moment-date }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name:"Address",
  props:["address"],
  computed: {
    address_name() {
      let first_name = this.address.attributes.first_name == null ? '' : this.address.attributes.first_name
      let last_name = this.address.attributes.last_name == null ? '' : this.address.attributes.last_name

      return (first_name + ' ' + last_name).trim()
    }
  },
  methods: {

    get_str_title()
    {
      var title = "Adresse"

      if ("customer" === this.address.attributes.address_type) {
        title += this.address.attributes.customer_usage === "main" ? " " : " de "

        title += this.getEnumTranslatedValue('address_customer_usage', this.address.attributes.customer_usage)
      } else if ("customer_representative" === this.address.attributes.address_type) {
        title += " de représentant légal"
      } else if ("mail_forward" === this.address.attributes.address_type) {
        title += " de réexpédition"
      }

      return title
    },
  }
}
</script>

<style scoped>
.validation_request_address_container {
  padding: 0 15px;
  border: solid 1px lightgray;
  background-color: white;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
}

.validation_request_address_container > div { margin-right: 15px; width: 100%; }
.validation_request_address_container > div:last-child { margin-right: 0; }

.addresse, .informations-complement {}
.addresse > h5, .informations-complement > h5 { border-bottom: 1px solid lightgray; padding-bottom: 5px; }

</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/ValidationRequestable/AddressV2.vue